import type { RoleListParams } from '../services/roles/roles.types'

/**
 * TanStack Query key factory for the Roles feature.
 *
 * `invalidateQueries({ queryKey: roleKeys.all })` refreshes every list / detail
 * / modules entry after a mutation.
 */
export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (params: RoleListParams) => [...roleKeys.lists(), params] as const,
  details: () => [...roleKeys.all, 'detail'] as const,
  detail: (roleId: number) => [...roleKeys.details(), roleId] as const,
  modules: () => [...roleKeys.all, 'modules'] as const,
}
